module.exports = __webpack_public_path__ + "deba47fdd40ed2573ae871a99c49f615.svg";